import { render, staticRenderFns } from "./DuringEvent.vue?vue&type=template&id=45a99c9b"
import script from "./DuringEvent.vue?vue&type=script&lang=js"
export * from "./DuringEvent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports